(function () {
    "use strict";

    angular.module('iMatApp')
        .decorator("$http", httpCancellationDecorator);

    httpCancellationDecorator.$inject = ["$delegate", "$q"];

    // Based on this example: https://www.exratione.com/2013/08/angularjs-wrapping-http-for-fun-and-profit/

    function httpCancellationDecorator($http, $q) {
        var wrapper = function () {
            // Apply global changes to arguments, or perform other nefarious acts.
            return $http.apply($http, arguments);
        };
        
        // $http has convenience methods such as $http.get() that we have to pass through as well.
        Object.keys($http)
            .filter(function (key) {
                return (typeof $http[key] === 'function');
            })
            .forEach(function (key) {
                wrapper[key] = function () {

                    var isCancelled = false;

                    var lastArg = arguments[arguments.length - 1];
                    if (angular.isObject(lastArg) && isPromise(lastArg.canceler)) {
                        // what about timeout promise ?
                        lastArg.timeout = lastArg.canceler;

                        lastArg.canceler.then(function () {
                            isCancelled = true;
                        });
                    }

                    var promise = $http[key].apply($http, arguments);

                    return promise.catch(function (reason) {
                        if (isCancelled) {
                            return $q.reject("CANCELED");
                        }

                        return $q.reject(reason);
                    });

                };
            });

        function isPromise(obj) {
            return angular.isObject(obj) && angular.isFunction(obj.catch);
        }

        return wrapper;
    }
}());